export const contactEmail = "contact@soemlabs.com";
